import { Component } from '@opten/compiler/metadata/component';
import { removeClass } from '@opten/dom/remove-class';
import { toggleClass } from '@opten/dom/toggle-class';
import { ModalComponent } from './modal';

@Component({ className: 'js-header' })
export class HeaderComponent {
	toggle: HTMLElement;
	backdrop: HTMLElement;

	constructor(private element: HTMLElement) {
		this.toggle = this.element.querySelector('.js-header-toggle');
		this.backdrop = this.element.querySelector('.js-header-backdrop');

		this.toggle.addEventListener('click', e => {
			e.preventDefault();
			if (ModalComponent.close()) {
				return;
			}
			toggleClass(document.body, 'header-is-open');
		});

		this.backdrop.addEventListener('click', e => {
			e.preventDefault();
			removeClass(document.body, 'header-is-open');
		});
	}
}
